import { render, staticRenderFns } from "./TdActions.vue?vue&type=template&id=7216f454&"
import script from "./TdActions.vue?vue&type=script&lang=ts&"
export * from "./TdActions.vue?vue&type=script&lang=ts&"
import style0 from "./TdActions.vue?vue&type=style&index=0&id=7216f454&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports